export class Forms {

    allowedTypesFile?: { [key: string]: string };

    constructor(config?: any) {
        this.allowedTypesFile = config?.allowedTypesFile || null;
    }

    validarCampos(formularioId: string, campos: { id: string; validaciones: string[], inputMsj: string }[]): boolean {
        let formularioValido = true;

        let move = false;
        campos.forEach((campo) => {
            const input = $(`#${campo.id}`);
            const mensaje = this.validarCampo(input, campo.validaciones);

            if (mensaje) {
                formularioValido = false;
                this.mostrarMensajesDeValidacion(input, [mensaje], campo.inputMsj);

                let top = input.offset()?.top;
                top = (top ? top : 0) - 300;

                if (!move) {
                    $('html, body').animate({
                        scrollTop: top
                    }, 10);

                    move = true;
                }

            } else {
                this.ocultarMensajesDeValidacion(input, campo.inputMsj);
            }
        });

        return formularioValido;
    }

    validarCampo(input: JQuery, validaciones: string[]): string | null {
        const valor = input.val() as string;
        const mensajesValidacion: string[] = [];

        if (validaciones.includes('required') && (!valor || valor.trim() === '' || valor === '0')) {
            mensajesValidacion.push('Este campo es requerido.');
        }

        if (validaciones.includes('email') && !this.validarEmail(valor)) {
            mensajesValidacion.push('Ingrese una dirección de correo electrónico válida.');
        }

        if (validaciones.includes('phone') && !this.validarTelefono(valor)) {
            mensajesValidacion.push('Ingrese un número de teléfono válido.');
        }

        if (validaciones.includes('number') && !/^[0-9]+$/.test(valor)) {
            mensajesValidacion.push('Este campo solo debe contener números.');
        }

        if (validaciones.includes('text') && !/^[\p{L}\s]+$/u.test(valor)) {
            mensajesValidacion.push('Este campo solo debe contener texto.');
        }

        // Validación personalizada para checkboxes con la clase "checkbox-validar"
        if (validaciones.includes('checked') && !input.is(':checked')) {
            mensajesValidacion.push('Debe aceptar los términos y condiciones.');
        }

        // Validación personalizada para checkboxes con la clase "checkbox-validar"
        if (validaciones.includes('checked-radio')) {
            // Supongamos que campo es el elemento jQuery con el ID especificado
            var radioSeleccionado = input.find('input[type="radio"]:checked');

            // Ahora, puedes obtener el valor del radio button seleccionado
            var valorSeleccionado = radioSeleccionado.val();

            if (!valorSeleccionado) mensajesValidacion.push('Debes seleccionar una opción');

        }

        // Nuevas validaciones para minlength y maxlength
        if (validaciones.includes('minlength')) {
            const minLength = parseInt(input.attr('minlength') || '0');
            if (valor.length < minLength) {
                mensajesValidacion.push(`Este campo debe tener al menos ${minLength} caracteres.`);
            }
        }

        if (validaciones.includes('maxlength')) {
            const maxLength = parseInt(input.attr('maxlength') || '0');
            if (valor.length > maxLength) {
                mensajesValidacion.push(`Este campo debe tener como máximo ${maxLength} caracteres.`);
            }
        }

        if (validaciones.includes('typeFile') && this.allowedTypesFile) {
            const files = (input[0] as HTMLInputElement)?.files || [];
            Array.from(files).forEach((file) => {
                if (!Object.values(this.allowedTypesFile || {})?.includes(file.type)) {
                    mensajesValidacion.push(
                        `El archivo "${file.name}" no es válido. Solo se aceptan (${Object.keys(this.allowedTypesFile || {}).join(', ')}).`
                    );
                }
            });
        }

        return mensajesValidacion.length > 0 ? mensajesValidacion[0] : null;
    }

    validarEmail(email: string): boolean {
        // Implementa tu propia lógica de validación de correo electrónico aquí
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    }

    validarTelefono(telefono: string): boolean {
        // Implementa tu propia lógica de validación de teléfono aquí
        return /^[0-9]{10}$/.test(telefono);
    }

    mostrarMensajesDeValidacion(input: JQuery, mensajes: string[], inputMsj?: string): void {
        const divFormGroup = inputMsj ? $(inputMsj) : input.closest('.input-paso3, .form-floating, .form-check');
        divFormGroup.removeClass('has-success').addClass('has-danger');

        const invalidFeedback = divFormGroup.find('.form-control-feedback');

        if (invalidFeedback.length === 0) {
            const feedbackDiv = $('<div>').addClass('form-control-feedback fs-6').text(mensajes.join(' '));

            if (inputMsj) {
                $(inputMsj).addClass('input-invalid').append(feedbackDiv);
            } else {
                input.addClass('input-invalid').after(feedbackDiv);
            }

        } else {
            invalidFeedback.text(mensajes.join(' '));
        }
    }

    ocultarMensajesDeValidacion(input: JQuery, inputMsj: string): void {
        const divFormGroup = inputMsj ? $(inputMsj) : input.closest('.input-paso3, .form-floating'); // Cambia la clase que busca
        divFormGroup.removeClass('has-danger').addClass('has-success');
        input.removeClass('input-invalid')
        const invalidFeedback = divFormGroup.find('.form-control-feedback');

        if (invalidFeedback.length > 0) {
            // Si el elemento existe, lo elimina
            invalidFeedback.remove();
        }
    }

    agregarManejadorDeEventos(campos: { id: string; validaciones: string[], inputMsj: string }[]): void {
        campos.forEach((campo) => {
            const input = $(`#${campo.id}`);
            input.on('input', () => {
                let validacion = this.validarCampo(input, campo.validaciones);
                if (!validacion) {
                    this.ocultarMensajesDeValidacion(input, campo.inputMsj);
                } else {
                    this.mostrarMensajesDeValidacion(input, [validacion], campo.inputMsj);
                }
            });
        });
    }
}
